<template>
    <div class="alert alert-accent alert-dismissible fade show mb-0" role="alert">
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      </button>
      <i class="fa fa-info mx-2"></i>
      <strong class="font-weight-bold">{{ message }}</strong>
    </div>
</template>

<script>
	export default {
		props: ['message']
	}
</script>